import { styled } from 'styled-system/jsx'

const Panel = styled('section', {
  base: {
    background:
      'linear-gradient(135deg, rgba(128, 84, 255, 0.08) 0%, rgba(193, 109, 255, 0.06) 100%)',
    border: '1.5px solid rgba(128, 84, 255, 0.2)',
    borderRadius: 'lg',
    padding: '16px 18px',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
})

const Eyebrow = styled('div', {
  base: {
    fontFamily: 'body',
    fontSize: '11px',
    fontWeight: '700',
    letterSpacing: '0.6px',
    textTransform: 'uppercase',
    color: 'quickpass.primary',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
  },
})

const Glyph = styled('span', {
  base: {
    fontSize: '14px',
  },
})

const Headline = styled('h4', {
  base: {
    fontFamily: 'display',
    fontSize: '17px',
    fontWeight: '700',
    color: 'quickpass.ink',
    margin: '0',
    letterSpacing: '-0.2px',
    lineHeight: '1.3',
  },
})

const WinnerLine = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    fontWeight: '600',
    color: 'quickpass.primary',
    margin: '0',
  },
})

const Reasoning = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    color: 'quickpass.ink',
    margin: '0',
    lineHeight: '1.55',
  },
})

const ProsGrid = styled('div', {
  base: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '12px',
    paddingTop: '4px',
  },
})

const ProsColumn = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },
})

const ProsHeader = styled('div', {
  base: {
    fontFamily: 'body',
    fontSize: '11px',
    fontWeight: '700',
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
    color: 'quickpass.inkSoft',
  },
})

const ProsList = styled('ul', {
  base: {
    listStyle: 'none',
    margin: '0',
    padding: '0',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
})

const ProsItem = styled('li', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    color: 'quickpass.ink',
    paddingLeft: '14px',
    position: 'relative',
    lineHeight: '1.45',
    _before: {
      content: '"+"',
      position: 'absolute',
      left: '0',
      color: 'quickpass.success',
      fontWeight: '700',
    },
  },
})

const SwingFactor = styled('div', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    color: 'quickpass.inkSoft',
    fontStyle: 'italic',
    paddingTop: '6px',
    borderTop: '1px dashed rgba(128, 84, 255, 0.2)',
  },
})

const SkeletonLine = styled('div', {
  base: {
    backgroundColor: 'rgba(128, 84, 255, 0.12)',
    borderRadius: 'sm',
    height: '12px',
    width: '70%',
  },
})

const QuietText = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    color: 'quickpass.inkSoft',
    fontStyle: 'italic',
  },
})

const ErrorText = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    color: 'quickpass.warmth',
    fontWeight: '600',
  },
})

export {
  Panel,
  Eyebrow,
  Glyph,
  Headline,
  WinnerLine,
  Reasoning,
  ProsGrid,
  ProsColumn,
  ProsHeader,
  ProsList,
  ProsItem,
  SwingFactor,
  SkeletonLine,
  QuietText,
  ErrorText,
}
